import InfoImagePreview from "./InfoImagePreview";

const FormInfoImage = ({ field }) => {
  return <InfoImagePreview key={field.id} config={field.config} />;
};

export default FormInfoImage;
